export default "__VITE_ASSET__51deddaa__"